module.exports = __webpack_public_path__ + "img/生物科技.6d7b25ce.png";